module.exports = __webpack_public_path__ + "img/_profile.c918c5d6.svg";